import { ItemConfig } from './types'

const CM_PX = 78.7

const P_SIZE = 9000

const sizes = {
  S: 0.846,
  M: 0.897,
  L: 0.948,
  XL: 1,
}

export const BIG_SILHOUETTE_TSHIRT_CONFIG: ItemConfig = {
  name: 'United Athle 5.6oz ビッグシルエットTシャツ',
  vendor: 'キャブ',
  vendor_code: '550801',
  printable_sections: ['103', '105'],
  colors: [
    { name: 'ホワイト', hex: '#FFFFFF', system_id: '001' },
    { name: 'ブラック', hex: '#111011', system_id: '002' },
  ],
  sizes: ['S', 'M', 'L', 'XL'],
  sections: [
    {
      name: '胸中央',
      id: '103',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '左胸',
      id: '101',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右胸',
      id: '102',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '背中中央',
      id: '105',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '襟下',
      id: '109',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '左袖',
      id: '107',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右袖',
      id: '108',
      config: {
        width: 787,
        height: 787,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: P_SIZE,
      height: P_SIZE,
      origin: { x: P_SIZE / 2, y: P_SIZE * 0.23 },
      sizes: sizes,
      sections: [
        {
          id: '103',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '101',
          offset: {
            x: 5 * CM_PX,
            y: 6 * CM_PX,
          },
        },
        {
          id: '102',
          offset: {
            y: 6 * CM_PX,
            x: -(5 * CM_PX + 787),
          },
        },
      ],
    },
    {
      name: 'back',
      width: P_SIZE,
      height: P_SIZE,
      origin: { x: P_SIZE / 2, y: P_SIZE * 0.19 },
      sizes: sizes,
      sections: [
        {
          id: '105',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '109',
          offset: {
            x: -(787 / 2),
            y: 2.5 * CM_PX,
          },
        },
      ],
    },
    {
      name: 'left',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3594 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '107',
          offset: {
            y: -(2 * CM_PX + 787),
            x: -(787 / 2),
          },
        },
      ],
    },
    {
      name: 'right',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3594 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '108',
          offset: { y: -(2 * CM_PX + 787), x: -(787 / 2) },
        },
      ],
    },
  ],
}
